import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-[1400px]">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">平台优势</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            为什么选择8848影院？四大核心优势给你答案
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-50 border border-background-200/60 p-6 text-center hover:border-primary-500/40 transition-all duration-200"
            >
              <div className="w-14 h-14 rounded-2xl bg-primary-500/10 flex items-center justify-center mx-auto mb-4">
                <i className={`${item.icon} text-primary-500 text-2xl w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}